/**
 * 多語言（i18n）配置
 * 支援繁體中文、英文
 */

import { zhTW } from './locales/zh-TW';
import { en } from './locales/en';

// 可用的語言列表
export const AVAILABLE_LANGUAGES = [
  {
    code: 'zh-TW',
    label: '繁體中文',
    shortLabel: '中',
    flag: '🇹🇼',
  },
  {
    code: 'en',
    label: 'English',
    shortLabel: 'EN',
    flag: '🇺🇸',
  },
];

// 語言包對應
export const TRANSLATIONS = {
  'zh-TW': zhTW,
  'en': en,
};

// 預設語言
export const DEFAULT_LANGUAGE = 'zh-TW';

// 從 localStorage 取得語言設定
export const getStoredLanguage = () => {
  try {
    return localStorage.getItem('language') || DEFAULT_LANGUAGE;
  } catch (error) {
    return DEFAULT_LANGUAGE;
  }
};

// 儲存語言設定到 localStorage
export const setStoredLanguage = (languageCode) => {
  try {
    localStorage.setItem('language', languageCode);
  } catch (error) {
    console.error('Failed to save language setting:', error);
  }
};

// 取得翻譯文字
export const getTranslation = (languageCode, key) => {
  const keys = key.split('.');
  let translation = TRANSLATIONS[languageCode] || TRANSLATIONS[DEFAULT_LANGUAGE];

  for (const k of keys) {
    if (translation == null) break;
    translation = translation[k];
  }

  // 空字串表示待翻譯，回傳空字串而非 key
  if (translation === '') return '';
  return translation || key;
};

export default {
  AVAILABLE_LANGUAGES,
  TRANSLATIONS,
  DEFAULT_LANGUAGE,
  getStoredLanguage,
  setStoredLanguage,
  getTranslation,
};
